import React from 'react';
import { useDevMode } from '../../contexts/DevModeContext';
import './Dev.css';

const DevTools = ({ children, className = '' }) => {
  const { isDevMode, toggleDevMode } = useDevMode();

  // Only render in development environment
  if (process.env.NODE_ENV === 'development') {
    return (
      <>
        <div className={`dev-tools ${className}`}>
          <div className="dev-tools-mode">
            <span>Mode:</span>
            <button
              onClick={toggleDevMode}
              className={`dev-tools-button ${isDevMode ? 'development' : 'client'}`}
            >
              {isDevMode ? 'Development' : 'Client'}
            </button>
          </div>
        </div>
        {children}
        {isDevMode && (
          <div className="dev-tools-panel">
            <button onClick={toggleDevMode}>Toggle Dev Mode</button>
            {/* Add other dev tools here */}
          </div>
        )}
      </>
    );
  }
  return children;
};

export default DevTools; 